import {Chips} from '../../Chip/Chips';
import {useFieldProps} from '../hooks/useFieldProps';
import {useOptionsManager} from '../hooks/useOptionsManager';
import {ChipsRendererResponseBody} from '../types/modelSchema';

export function ChipsRenderer(props: ChipsRendererResponseBody) {
  const {onChange, value, isRequired, error} = useFieldProps(props);
  const options = useOptionsManager(props.defaultOptions, props.dependentOptions, props.url);

  return (
    <Chips
      label={props.label}
      data-testid={props.name}
      tooltip={props.tooltip}
      value={value}
      isRequired={isRequired}
      errorMessage={error?.message}
      onChange={onChange}
      options={options}
      isDisabled={props.isReadOnly}
    />
  );
}
